'use client';

import type { FC } from 'react';
import { Pagination } from 'swiper/modules';
import type { SwiperProps } from 'swiper/react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

import { cn } from '@/lib/utils';

export interface SwiperElementProps extends SwiperProps {
    sliderClassName?: string;
    equalHeight?: boolean;
}

const SwiperElement: FC<SwiperElementProps> = ({
    className,
    children,
    sliderClassName,
    equalHeight,
    ...props
}) => (
    <Swiper
        className={cn('w-full', className)}
        modules={[Pagination]}
        {...props}
    >
        {Array.isArray(children) &&
            children.map((sliderContent, i) => (
                <SwiperSlide
                    key={'swiper-slide-' + i}
                    className={cn('max-w-fit', sliderClassName)}
                    style={
                        equalHeight
                            ? { height: 'auto', display: 'flex' }
                            : undefined
                    }
                >
                    {sliderContent}
                </SwiperSlide>
            ))}
    </Swiper>
);

export default SwiperElement;
